import {GoogleMap} from "@react-google-maps/api";
import {ReactNode, useEffect, useState} from "react";
import CommonClass from "@/utils/common.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";


interface Props {
    mapStyle?:any
    children:ReactNode
    center_setted?:any
}

const MapLayout:React.FC<Props> = ({mapStyle, children, center_setted}) => {
    
    const chisinauCoordinates = {
        lat: 47.023,
        lng: 28.842
    };
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")
    
    const [center, setCenter] = useState(chisinauCoordinates)
    const [loaded, setLoaded] = useState<any>(false)
    
    const setLocationsHandler = (loc:any) => {
        setCenter(CommonClass.convertCoordinatesToLatLng(loc.coordonates));
    }
    
    useEffect(() => {
        eventEmitter.on(CommonClass.CustomEvents.set_map_location, setLocationsHandler)
        
        
        let timeout = setTimeout(() => {
            if(debug==="true")console.info("setTimeout MapLayout")
            
            setLoaded(true)
            clearTimeout(timeout)
        }, 500)
        
        return () => {
            eventEmitter.off(CommonClass.CustomEvents.set_map_location, setLocationsHandler)
        }
    }, [])
    
    return (loaded && children) && (
        
        <GoogleMap
            mapContainerStyle={mapStyle ? mapStyle : {}}
            center={center_setted ? center_setted : center}
            zoom={12}
        >
            
            {children}
        
        </GoogleMap>
        
    )
}

export default MapLayout